exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item-table-data tr td, .item-table-main tr td\n{\n\twhite-space: unset !important;\n}\n.cart-loader\n{\n\tposition: absolute;\n    z-index: 10000;\n    width: 100%;\n    background: #ffffff4a;\n    height: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.call_center_wizard .wizard-nav-pills li:last-child {\n\tpointer-events: none !important;\n}\n", ""]);

// exports
